import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import TranslationState from './states/TranslationState';
import TranslateButton from './components/TranslateButton';
import DetectedLanguageLabel from './components/DetectedLanguageLabel';
import TranslatedCommentPost from './components/TranslatedCommentPost';
import DiscussionTitle from './components/DiscussionTitle';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
function languages() {
  const supported = app.forum.attribute('itqanTranslate.supportedLanguages') || {
    ar: 'ar',
    en: 'en'
  };
  return Object.values(supported);
}
app.initializers.add('itqan-translate', () => {
  // The API sends `detectedLang` as a plain attribute, but every component here
  // reads it as a model method (`post.detectedLang()`). Without the accessor the
  // language badge never rendered and the translation source label fell back to
  // "unknown language". Add it only if nothing else already defines it.
  if (typeof Discussion.prototype.detectedLang !== 'function') {
    Discussion.prototype.detectedLang = function () {
      return this.attribute('detectedLang');
    };
  }
  if (typeof Post.prototype.detectedLang !== 'function') {
    Post.prototype.detectedLang = function () {
      return this.attribute('detectedLang');
    };
  }

  // --- posts -------------------------------------------------------------
  extend(CommentPost.prototype, 'oninit', function () {
    this.tqaTranslationState = new TranslationState(this.attrs.post, 'post');
    this.subtree?.check(() => this.tqaTranslationState.loading, () => this.tqaTranslationState.showing, () => this.tqaTranslationState.currentTranslation);
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const detectedLang = this.attrs.post.detectedLang?.();
    const user = app.session.user;
    if (!detectedLang || this.attrs.post.isHidden()) {
      return;
    }
    if (detectedLang === app.translator.getLocale() && !user?.preferences()?.['itqan-translate.labelAllSource']) {
      return;
    }
    items.add('detected-language', m(DetectedLanguageLabel, {
      detectedLang: detectedLang,
      context: "post"
    }), -5);
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    if (this.attrs.post.isHidden()) {
      return;
    }
    items.add('translate', m(TranslateButton, {
      languages: languages(),
      detectedLang: this.attrs.post.detectedLang?.(),
      loading: this.tqaTranslationState.loading,
      onTranslate: code => this.tqaTranslationState.loadTranslation(code)
    }), 10);
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    if (this.isEditing?.()) {
      this.tqaTranslationState.closeTranslation();
      return;
    }
    if (this.tqaTranslationState.showing || this.tqaTranslationState.loading) {
      items.add('translated-content', m(TranslatedCommentPost, {
        state: this.tqaTranslationState,
        post: this.attrs.post
      }), -10);
    }
  });

  // --- discussion title --------------------------------------------------
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    items.setContent('title', m(DiscussionTitle, {
      discussion: discussion,
      languages: languages(),
      iconOnly: false
    }));
    return items;
  });
});